import * as React from 'react';
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
import { reduxForm } from 'redux-form';
const { connect } = require('react-redux');
import * as c from 'models/constants';
import { closeModal, showModal } from 'redux/modules/modal';
import { getBookingTemplatesByOffice, resetBookingTemplatesData } from 'redux/modules/shop/bookingtemplates';
import { Dispatch } from 'react-redux';
import { InjectedFormProps, IServiceCategoryDomainValue, ITranslateProps } from 'models/common';
import { LoadingOverlayWrapper } from 'components/Loader';
import { Button } from 'components/Common/Button';
import { domainValuesMap } from 'redux/modules/domainvalues';
import { SortEndHandler } from 'react-sortable-hoc';
import { ServiceCategoryList, AllServiceCategories } from './HelperComponents';
import renderIcon from 'helpers/renderIcon';
import {
	getOfficeServiceGroups,
	resetServiceGroupsData,
	submitServiceGroupsForm,
} from 'redux/modules/shop/serviceGroups';
import { IServiceGroup, IServiceGroupsForm, IServiceTree } from 'models/shop/serviceGroups';
import { Link, RouteComponentProps } from 'react-router';
import { IShopCard } from 'models/shop/shopcard';
import { initialFormValues, serviceCategoryToKey } from 'redux/modules/shop/serviceGroups/helpers';
import { ErrorSummary } from 'components';
import { ISaveShopServiceTemplateOwnProps } from './SaveShopServiceTemplate';
import { ILoadShopServiceTemplateOwnProps } from './LoadShopServiceTemplate';

interface IOwnProps extends Pick<RouteComponentProps<any, any>, 'route' | 'routes' | 'router'> {
	shopId: string;
	shopTypes: IShopCard['shopTypes'];
	officeId: string;
	officeSelector?: JSX.Element;
	serviceCategory?: IServiceCategoryDomainValue['key'];
	editMode: boolean;
	currencyKey?: number;

	changeServiceCategory?: (key: IServiceCategoryDomainValue['key']) => void;
	toggleEditMode?: (manualSet?: boolean) => void;
}

interface IProps
	extends IOwnProps,
		ITranslateProps,
		ReturnType<typeof mapStateToProps>,
		ReturnType<typeof mapDispatchToProps>,
		InjectedFormProps<IServiceGroupsForm> {}

interface IState {
	activeGroup: IServiceGroup['id'] | undefined;
	draggingServiceFromGroup: IServiceGroup['id'] | undefined;
	optionsVisible: boolean;
	addNewVisible: boolean;
	mobileOptionsVisible: boolean;
	mobileAddNewVisible: boolean;
	isServiceGroupBeingDragged: boolean;
	isServiceCategoryBeingDragged: boolean;
	isServiceGroupSortMode: boolean;
	isServiceCategorySortMode: boolean;
}

const mapStateToProps = (state: IStore, ownProps: IOwnProps) => {
	let currentFormValues: Partial<IServiceGroupsForm> = {};

	if (state.form[c.FORM_NAME_SERVICES_TREE] && state.form[c.FORM_NAME_SERVICES_TREE].values) {
		currentFormValues = state.form[c.FORM_NAME_SERVICES_TREE].values;
	}

	return {
		currentFormValues,
		initialValues: initialFormValues(state, ownProps.shopId, ownProps.officeId),
		isFetching:
			state.shopBookingTemplates.isFetching ||
			state.serviceGroups.isFetching ||
			state.domainValues.isFetchingServiceCategories,
		categories: state.domainValues.categories,
		serviceCategories: state.domainValues.serviceCategories,
		serviceGroups: state.serviceGroups.serviceGroups,
		shopcard: state.shopcard.shopcard,
		errors: state.serviceGroups.error,
		message: state.serviceGroups.message,
	};
};

const mapDispatchToProps = (dispatch: Dispatch<IStore>, ownProps: IOwnProps) => {
	const getServicesAndGroups = () =>
		Promise.all([
			dispatch(getBookingTemplatesByOffice(ownProps.officeId, true)),
			dispatch(getOfficeServiceGroups(ownProps.officeId)),
		]);
	return {
		getServicesAndGroups,
		resetServicesAndGroups: () =>
			Promise.all([dispatch(resetBookingTemplatesData()), dispatch(resetServiceGroupsData())]),
		getDomainValues: () =>
			Promise.all([dispatch(domainValuesMap.categories()), dispatch(domainValuesMap.serviceCategories())]),
		submitForm: (f: IServiceGroupsForm, serviceCategoryIds: number[]) =>
			dispatch(submitServiceGroupsForm(f, ownProps.shopId, ownProps.officeId, serviceCategoryIds)).then(() =>
				getServicesAndGroups(),
			),
		openLoadTemplate: () => {
			const props: ILoadShopServiceTemplateOwnProps = {
				shopId: ownProps.shopId,
				officeId: ownProps.officeId,
				closeModal: () => {
					getServicesAndGroups();
					dispatch(closeModal());
				},
			};
			dispatch(showModal('LoadShopServiceTemplate', props));
		},
		openSaveTemplate: () => {
			const props: ISaveShopServiceTemplateOwnProps = {
				officeId: ownProps.officeId,
				shopId: ownProps.shopId,
			};
			dispatch(showModal('SaveShopServiceTemplate', props));
		},
		openAddEditServiceGroup: (
			servicesFormData: Partial<IServiceGroupsForm>,
			serviceCategories: IServiceCategoryDomainValue[],
			shopTypes: number[],
			afterAddingEditingGroup,
			mode: 'add' | 'edit',
			serviceGroupData?: IServiceTree & IServiceGroup,
		) => {
			const props = {
				officeId: ownProps.officeId,
				servicesFormData,
				serviceCategories,
				shopTypes,
				afterAddingEditingGroup,
				mode,
				serviceGroupData,
			};
			dispatch(showModal('AddEditServiceGroup', props));
		},
	};
};

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ServicesListEditForm extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			activeGroup: undefined,
			draggingServiceFromGroup: undefined,
			optionsVisible: false,
			addNewVisible: false,
			mobileOptionsVisible: false,
			mobileAddNewVisible: false,
			isServiceGroupBeingDragged: false,
			isServiceCategoryBeingDragged: false,
			isServiceCategorySortMode: false,
			isServiceGroupSortMode: false,
		};

		this.setActiveCategory = this.setActiveCategory.bind(this);
		this.startDraggingServiceGroup = this.startDraggingServiceGroup.bind(this);
		this.stopDraggingServiceGroup = this.stopDraggingServiceGroup.bind(this);
		this.startDraggingService = this.startDraggingService.bind(this);
		this.stopDraggingService = this.stopDraggingService.bind(this);
		this.startDraggingServiceCategory = this.startDraggingServiceCategory.bind(this);
		this.stopDraggingServiceCategory = this.stopDraggingServiceCategory.bind(this);
		this.toggleServiceGroupShrink = this.toggleServiceGroupShrink.bind(this);

		this.afterAddingEditingGroup = this.afterAddingEditingGroup.bind(this);
		this.submitForm = this.submitForm.bind(this);
		this.closeDropdownsCallback = this.closeDropdownsCallback.bind(this);
	}

	closeDropdownsCallback() {
		if (this.state.optionsVisible) this.setState({ optionsVisible: false });

		if (this.state.addNewVisible) this.setState({ addNewVisible: false });

		document.removeEventListener('click', this.closeDropdownsCallback);
	}

	public componentDidMount() {
		this.props.getServicesAndGroups();
		this.props.getDomainValues();
	}

	public componentWillUnmount() {
		this.props.resetServicesAndGroups();
		document.removeEventListener('click', this.closeDropdownsCallback);
	}

	public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>): void {
		const { officeId, isFetching, reset } = this.props;
		if (prevProps.serviceCategory !== this.props.serviceCategory) {
			reset();
		}
		if (prevProps.officeId !== officeId && !isFetching) {
			reset();
			this.props.getServicesAndGroups();
		}

		if (
			(!prevState.optionsVisible && this.state.optionsVisible) ||
			(!prevState.addNewVisible && this.state.addNewVisible)
		) {
			document.addEventListener('click', this.closeDropdownsCallback);
		}
	}

	private setActiveCategory(activeCategory: IState['activeGroup']) {
		if (this.state.activeGroup !== activeCategory) {
			this.setState({ activeGroup: activeCategory });
		}
	}

	private startDraggingServiceCategory() {
		this.setState({ isServiceCategoryBeingDragged: true });
	}

	private toggleServiceGroupShrink(afterSaving: boolean = false) {
		this.setState((state) => ({
			isServiceGroupSortMode: afterSaving ? false : !state.isServiceGroupSortMode,
			isServiceCategorySortMode: false,
		}));
		this.props.change(
			'numberOfTimesServiceGroupToggled',
			this.props.currentFormValues.numberOfTimesServiceGroupToggled + 1,
		); // Force rerender of FieldArray, you need to change something in redux state to rerender FieldArray (of ProtoGroupsList in this case), changing React props or state does not affect FieldArray!!!
	}

	private stopDraggingServiceCategory(a: Parameters<SortEndHandler>[0]) {
		const { array } = this.props;
		const { oldIndex, newIndex } = a;
		array.move('serviceCategoryTree', oldIndex, newIndex);
		this.setState({ isServiceCategoryBeingDragged: false });
	}

	private startDraggingServiceGroup() {
		this.setState({ isServiceGroupBeingDragged: true });
	}

	private stopDraggingServiceGroup(a: Parameters<SortEndHandler>[0], key: number) {
		const { array } = this.props;
		const { oldIndex, newIndex } = a;
		array.move(`serviceCategoryTree.${key}`, oldIndex, newIndex);
		this.setState({ isServiceGroupBeingDragged: false });
	}

	private startDraggingService(s: IServiceGroup) {
		if (this.state.draggingServiceFromGroup !== s.id) {
			this.setState({ draggingServiceFromGroup: s.id });
		}
	}

	private stopDraggingService(a: Parameters<SortEndHandler>[0], c: IServiceGroup, k: number) {
		const { array, currentFormValues } = this.props;
		const destinationGroup = this.state.activeGroup;
		const index = currentFormValues?.serviceCategoryTree.findIndex((sc) => {
			return sc.findIndex((sg) => sg.serviceCategoryId === k) !== -1;
		});

		if (index < 0) {
			console.error('No index found');
			return;
		}

		const workingBase = currentFormValues?.serviceCategoryTree[index];
		const childrenPath = (groupIndex: number) => `serviceCategoryTree.${index}.${groupIndex}.children`;

		if (!workingBase) {
			console.error('No working base');
			return;
		}

		if (!destinationGroup) {
			console.warn('Unknown destination group');
		}

		if (!c.id) {
			console.error('Missing id', c);
			return;
		}

		const sourceIndex = workingBase.findIndex((cc) => cc.id === c.id);
		if (sourceIndex < 0) {
			console.error('Cannot find sourceIndex for', c);
			return;
		}

		if (!destinationGroup || c.id === destinationGroup) {
			array.move(childrenPath(sourceIndex), a.oldIndex, a.newIndex);
		} else {
			const destinationIndex = workingBase.findIndex((cc) => cc.id === destinationGroup);
			if (destinationIndex < 0) {
				console.error('Cannot find destinationIndex for', destinationGroup);
				return;
			}
			const item = workingBase[sourceIndex].children?.[a.oldIndex];
			if (!item) {
				console.error('No item on index ' + a.oldIndex);
			}
			array.remove(childrenPath(sourceIndex), a.oldIndex);
			array.push(childrenPath(destinationIndex), item);
		}

		this.setState({ draggingServiceFromGroup: undefined });
	}

	// Remove basePrefix as it is not needed anymore
	get basePrefix(): string | null {
		const c = this.selectedServiceCategory;
		return c ? serviceCategoryToKey(c) : null;
	}

	afterAddingEditingGroup() {
		// refresh and fetch new data
		this.props.resetServicesAndGroups().then(() => {
			this.props.getServicesAndGroups().then(() => {
				///////////////////////////////////
				// Scroll newly added group container into view
				///////////////////////////////////
				setTimeout(() => {
					document
						.querySelector(`.servicesCategory.is-active.sortable`)
						?.scrollIntoView({ behavior: 'smooth', block: 'center' });
				}, 150);
				///////////////////////////////////
			});
		});
	}

	get validServiceCategories() {
		const { serviceCategories, shopTypes, currentFormValues } = this.props;

		if (!serviceCategories?.length || !Array.isArray(shopTypes)) {
			return null;
		}

		const alreadyUsed: number[] =
			currentFormValues?.serviceCategoryTree?.map((sc) => sc[0]?.serviceCategoryId).filter(Boolean) || [];

		// intersect
		return serviceCategories.filter(
			(sc) => alreadyUsed.includes(sc.key) || shopTypes.some((st) => sc.serviceCategoryShopTypes.includes(st)),
		);
	}

	get selectedServiceCategory() {
		return this.props.serviceCategory || this.validServiceCategories?.[0]?.key;
	}

	private submitForm(form: IServiceGroupsForm) {
		const serviceCategoriesOrdered: number[] = form.serviceCategoryTree.map((tree) => tree[0]?.serviceCategoryId);
		// Append deleted service categories to the end so they get deleted
		this.props.initialValues.serviceCategoryTree.map((tree) => {
			if (!serviceCategoriesOrdered.includes(tree[0]?.serviceCategoryId)) {
				serviceCategoriesOrdered.push(tree[0].serviceCategoryId);
			}
		});

		this.props.submitForm(form, serviceCategoriesOrdered).then(() => {
			this.props.toggleEditMode(false);
			this.toggleServiceGroupShrink(true);
		});
	}

	private showOptionsSwitch = () => {
		this.setState({ optionsVisible: !this.state.optionsVisible, addNewVisible: false });
	};

	private showAddNewSwitch = () => {
		this.setState({ addNewVisible: !this.state.addNewVisible, optionsVisible: false });
	};

	private showOptionsSwitchMobile = () => {
		this.setState({ mobileOptionsVisible: !this.state.mobileOptionsVisible });
	};

	private showAddNewSwitchMobile = () => {
		this.setState({ mobileAddNewVisible: !this.state.mobileAddNewVisible });
	};

	render() {
		const { officeId, currentFormValues, isFetching, officeSelector, handleSubmit, pristine, submitting, t } =
			this.props;
		const basePrefix = this.basePrefix;

		if (!officeId || !Object.keys(currentFormValues)?.length) {
			return null;
		}

		if (!this.selectedServiceCategory || !basePrefix) {
			return <div>No category selected</div>;
		}

		const allServiceCategoriesTree: JSX.Element[] = [];

		// Go through each service category that exists
		currentFormValues?.serviceCategoryTree.forEach((tree, idx) => {
			if (tree?.length) {
				const keyNumber = tree[0]?.serviceCategoryId;

				// Drag & drop between containers
				const activeDifferentCategory =
					this.state.draggingServiceFromGroup && this.state.draggingServiceFromGroup !== this.state.activeGroup
						? this.state.activeGroup
						: undefined;

				const tempTree: JSX.Element = (
					<ServiceCategoryList
						{...this.props}
						prefix={`serviceCategoryTree[${idx}]`}
						activeDifferentGroup={activeDifferentCategory}
						setActiveGroup={this.setActiveCategory}
						startSortingServiceGroup={this.startDraggingServiceGroup}
						endSortingServiceGroup={this.stopDraggingServiceGroup}
						startSortingService={this.startDraggingService}
						endSortingService={this.stopDraggingService}
						selectedServiceCategory={keyNumber}
						openAddEditServiceGroup={(serviceGroupData) =>
							this.props.openAddEditServiceGroup(
								this.props.currentFormValues,
								this.props.serviceCategories,
								this.props.shopTypes,
								this.afterAddingEditingGroup,
								'edit',
								serviceGroupData,
							)
						}
						editMode={this.props.editMode}
						key={`list${keyNumber}`}
						index={idx}
						currencyKey={this.props.currencyKey}
						isServiceGroupBeingDragged={this.state?.isServiceGroupBeingDragged}
						isServiceCategoryBeingDragged={this.state?.isServiceCategoryBeingDragged}
						isServiceCategorySortMode={this.state?.isServiceCategorySortMode}
						isServiceGroupSortMode={this.state?.isServiceGroupSortMode}
						categoryIndex={idx}
					/>
				);

				allServiceCategoriesTree.push(tempTree);
			}
		});

		return (
			<form className="servicesList col-xl-7 col-lg-9" onSubmit={handleSubmit(this.submitForm)}>
				<LoadingOverlayWrapper className="subsection-main" spinner={isFetching || submitting}>
					<div className="servicesList__headerContainer__desktop">
						<h1>{t('User_ShopCard_Services')}</h1>
					</div>
					<div className="servicesList__optionsHolder servicesList__optionsHolder__desktop">
						<div className="row align-items-center">
							<div className="col-8">
								{officeSelector}
								{this.props?.shopcard?.offices.length < 2 ? (
									<div className="servicesList__optionsHolder__singleOffice">
										<div className="servicesList__optionsHolder__singleOffice__imageContainer">
											{this.props?.shopcard?.picture ? (
												<img src={this.props?.shopcard?.picture} />
											) : (
												renderIcon(
													'pfp_salon',
													30,
													30,
													'servicesList__optionsHolder__singleOffice__imageContainer__noIcon',
												)
											)}
										</div>
										<div className="servicesList__optionsHolder__singleOffice__namesContainer">
											<span className="servicesList__optionsHolder__singleOffice__shopName">
												{this.props?.shopcard?.name}
											</span>
											<span className="servicesList__optionsHolder__singleOffice__officeName">
												{this.props?.shopcard?.offices[0]?.name}
											</span>
										</div>
									</div>
								) : null}
							</div>
							<div className="col-4 servicesList__options_buttons">
								<div className="servicesList__dropdown_container">
									<div className="servicesList__optionsHolder__options" onClick={() => this.showOptionsSwitch()}>
										{renderIcon('options', 20, 20)}
										<span className="servicesList__optionsHolder__options__text">
											{t('User_ShopCard_Services_Options')}
										</span>
									</div>
									{this.state.optionsVisible && (
										<div className="servicesList__optionsHolder__optionsContainer">
											<div
												className="servicesList__optionsHolder__optionsContainer__text"
												onClick={() => this.props.toggleEditMode()}
											>
												{t('User_ShopCard_Services_ReorderServices')}
											</div>
											<div
												onClick={this.props.openSaveTemplate}
												className="servicesList__optionsHolder__optionsContainer__text"
											>
												{t('User_ShopCard_Services_SaveAsTemplate_Button')}
											</div>
											<div
												onClick={this.props.openLoadTemplate}
												className="servicesList__optionsHolder__optionsContainer__text"
											>
												{t('User_ShopCard_Services_LoadTemplate_Button')}
											</div>
										</div>
									)}
								</div>
								<div className="servicesList__dropdown_container">
									<div className="servicesList__optionsHolder__addNew" onClick={() => this.showAddNewSwitch()}>
										{renderIcon('nikaPlus', 20, 20)}
										<span className="servicesList__optionsHolder__addNew__text">
											{t('User_ShopCard_Services_AddNew')}
										</span>
									</div>
									{this.state.addNewVisible && (
										<div className="servicesList__optionsHolder__addNewContainer">
											{this.props?.serviceGroups?.length ? (
												<Link to={`/shop/${this.props.shopId}/${this.props.officeId}/choose-service`}>
													<div className="servicesList__optionsHolder__addNewContainer__text">
														{t('User_ShopCard_Services_AddANewService')}
													</div>
												</Link>
											) : null}
											<div
												className="servicesList__optionsHolder__addNewContainer__text"
												onClick={() =>
													this.props.openAddEditServiceGroup(
														this.props.currentFormValues,
														this.props.serviceCategories,
														this.props.shopTypes,
														this.afterAddingEditingGroup,
														'add',
													)
												}
											>
												{t('User_ShopCard_Services_AddANewServiceGroup')}
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>

					<div className="servicesList__optionsHolder__mobile">
						<div className="row align-items-center">
							<div className="col-12">
								<div className="servicesList__optionsHolder__mobileHeader">
									<h1 className="servicesList__optionsHolder__mobileTitle">{t('User_ShopCard_Services')}</h1>
									<div className="servicesList__optionsHolder__mobileOptionsContainer">
										<div
											className="servicesList__optionsHolder__mobileOptions"
											onClick={() => this.showOptionsSwitchMobile()}
										>
											{renderIcon('options', 20, 20)}
										</div>
										<div
											className="servicesList__optionsHolder__mobileAddNew"
											onClick={() => this.showAddNewSwitchMobile()}
										>
											{renderIcon('nikaPlus', 20, 20)}
										</div>
									</div>
								</div>
							</div>
							<div className="col-12">{officeSelector}</div>
							<div className="col-2">
								{this.state.optionsVisible && (
									<div
										className="servicesList__optionsHolder__optionsContainer"
										onMouseLeave={() => this.setState({ optionsVisible: false })}
									></div>
								)}
							</div>
							<div className="col-2">
								{this.state.addNewVisible && (
									<div
										className="servicesList__optionsHolder__addNewContainer"
										onMouseLeave={() => this.setState({ addNewVisible: false })}
									></div>
								)}
							</div>
						</div>
					</div>

					<ErrorSummary error={this.props.errors} message={this.props.message} />

					<div className="servicesList__serviceGroups">
						<AllServiceCategories
							allServiceCategoriesTree={allServiceCategoriesTree}
							axis="y"
							lockAxis="y"
							useWindowAsScrollContainer={true}
							useDragHandle={true}
							updateBeforeSortStart={() => this.startDraggingServiceCategory()}
							onSortEnd={(a) => this.stopDraggingServiceCategory(a)}
							isServiceCategoryBeingDragged={this.state?.isServiceCategoryBeingDragged}
							isServiceGroupBeingDragged={this.state?.isServiceGroupBeingDragged}
							isServiceCategorySortMode={this.state?.isServiceCategorySortMode}
							isServiceGroupSortMode={this.state?.isServiceGroupSortMode}
							editMode={this.props.editMode}
						/>
					</div>
					{(this.props.editMode ||
						JSON.stringify(this.props.currentFormValues.serviceCategoryTree) !==
							JSON.stringify(this.props.initialValues.serviceCategoryTree)) && (
						<div className="servicesList__bottomContainer">
							<div className="container">
								<div className="row justify-content-center">
									<div className="col-xl-7 col-lg-9 col-12">
										<div className="servicesList__bottomContainer__groupsToggle">
											{this.state.isServiceGroupSortMode
												? renderIcon('expandGroups', 64, 64, '', () => {
														this.toggleServiceGroupShrink();
												  })
												: renderIcon('shrinkGroups', 64, 64, '', () => {
														this.toggleServiceGroupShrink();
												  })}
										</div>
										<div className="servicesList__bottomContainer__buttons">
											<div
												className="servicesList__bottomContainer__cancelButton"
												onClick={() => {
													this.props.toggleEditMode(false);
													this.props.reset();
													this.setState({ isServiceCategorySortMode: false, isServiceGroupSortMode: false });
												}}
											>
												{t('BSPortal_Common_Cancel')}
											</div>
											<Button disabled={isFetching || pristine || submitting} type="submit">
												{t('BSPortal_Common_Save')}
											</Button>
										</div>
									</div>
								</div>
							</div>
						</div>
					)}

					{(this.state.mobileOptionsVisible || this.state.mobileAddNewVisible) && (
						<div
							className="servicesList__shadow"
							onClick={() => this.setState({ mobileOptionsVisible: false, mobileAddNewVisible: false })}
						></div>
					)}

					{this.state.mobileOptionsVisible && (
						<div className="servicesList__mobileOptionsContainer">
							<div
								className="servicesList__mobileOptionsContainer__text"
								onClick={() => {
									this.props.toggleEditMode();
									this.setState({ mobileOptionsVisible: false });
								}}
							>
								{t('User_ShopCard_Services_ReorderServices')}
							</div>
							<div
								onClick={() => {
									this.showOptionsSwitchMobile();
									this.props.openSaveTemplate();
								}}
								className="servicesList__mobileOptionsContainer__text"
							>
								{t('User_ShopCard_Services_SaveAsTemplate_Button')}
							</div>
							<div
								onClick={() => {
									this.showOptionsSwitchMobile();
									this.props.openLoadTemplate();
								}}
								className="servicesList__mobileOptionsContainer__text"
							>
								{t('User_ShopCard_Services_LoadTemplate_Button')}
							</div>
						</div>
					)}

					{this.state.mobileAddNewVisible && (
						<div className="servicesList__mobileAddNewContainer">
							{this.props?.serviceGroups?.length ? (
								<Link to={`/shop/${this.props.shopId}/${this.props.officeId}/choose-service`}>
									<div className="servicesList__mobileAddNewContainer__text">
										{t('User_ShopCard_Services_AddANewService')}
									</div>
								</Link>
							) : null}
							<div
								className="servicesList__mobileAddNewContainer__text"
								onClick={() => {
									this.showAddNewSwitchMobile();
									this.props.openAddEditServiceGroup(
										this.props.currentFormValues,
										this.props.serviceCategories,
										this.props.shopTypes,
										this.afterAddingEditingGroup,
										'add',
									);
								}}
							>
								{t('User_ShopCard_Services_AddANewServiceGroup')}
							</div>
						</div>
					)}
				</LoadingOverlayWrapper>
			</form>
		);
	}
}

let ServicesListEdit: React.ComponentType<IOwnProps> = reduxForm(
	{
		form: c.FORM_NAME_SERVICES_TREE,
		enableReinitialize: true,
	},
	mapStateToProps,
)(ServicesListEditForm);
ServicesListEdit = connect(mapStateToProps, mapDispatchToProps)(ServicesListEdit);

export { ServicesListEdit };
